// Helper Functions

// Extend Flickity for equal cell-height hack
Flickity.prototype._createResizeClass = function () {
  this.element.classList.add("flickity-resize");
};

Flickity.createMethods.push("_createResizeClass");

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
  this.element.classList.remove("flickity-resize");
  resize.call(this);
  this.element.classList.add("flickity-resize");
};

const debounce = (f, delay) => {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => f.apply(this, args), delay);
  };
};

const moneyFormat = (amount) => {
  return `$${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
};

class WidgetAmbassador extends HTMLElement {
  constructor() {
    super();

    const list = this.querySelector(".list-menu");
    if (!list || list.children.length < 6) {
      return;
    }

    const div = document.createElement("div");
    div.classList.add("show-more-wrapper", "ta-center");
    div.innerHTML = '<button type="button">+ Show More</button>';
    this.appendChild(div);

    const checkQuery = (e) => {
      if (e.matches) this.classList.add("active");
      else this.classList.remove("active");
    };

    const mq = window.matchMedia("(min-width: 960px)");
    mq.addEventListener("change", checkQuery);
    checkQuery(mq);

    const button = div.querySelector("button");
    button.addEventListener("click", () => {
      this.classList.add("is-shown");
    });
  }
}

customElements.define("widget-ambassador", WidgetAmbassador);

class WidgetScroll extends HTMLElement {
  constructor() {
    super();

    this.elem = this.querySelector(".custom-scroll");
    if (!this.elem) return;

    const hasScrollableContent = this.elem.scrollWidth > this.elem.clientWidth;
    const overflowStyle = window.getComputedStyle(this.elem).overflowX;
    const isOverflowHidden = overflowStyle.indexOf("hidden") !== -1;

    if (hasScrollableContent && !isOverflowHidden) {
      this.classList.add("is-scrollable");
    } else {
      this.classList.remove("is-scrollable");
    }
  }
}

customElements.define("widget-scroll", WidgetScroll);

class WidgetSlider extends HTMLElement {
  constructor() {
    super();

    // Default slider settings
    this.settings = {
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      autoPlay: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20,
      },
      on: {
        ready: function () {
          this.resize();
        },
        staticClick: function (event, pointer, cellElement, cellIndex) {
          if (!cellElement) return;
          const article = cellElement.querySelector("article");
          const link = article ? article.dataset.link : null;
          if (!link) return;
          window.location = link;
        },
      },
    };

    // Initialize slider only if there are more than 1 slider block
    if (this.children.length > 1) {
      this.#init();
    }
  }

  #init() {
    // Add custom data attr slider settings
    const { sliderSettings: customSettings } = this.dataset;
    if (customSettings) Object.assign(this.settings, JSON.parse(customSettings));

    // Enable flickity slider
    new Flickity(this, this.settings);

    // Reinitialize slider on window resize
    const observer = new ResizeObserver(
      debounce(([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) flkty.resize();
      }, 200)
    );
    observer.observe(this);
  }
}

customElements.define("widget-slider", WidgetSlider);

class StickyProductATC extends HTMLElement {
  constructor() {
    super();

    this.script = this.querySelector("script");
    this.data = this.script ? JSON.parse(this.script.innerText) : null;
    if (!this.data) return;

    this.productContainer = document.querySelector(".product__info-wrapper");
    this.form = this.productContainer
      ? this.productContainer.querySelector('form[action="/cart/add"][data-type="add-to-cart-form"]')
      : null;
    if (!this.form) return;

    this.qtyInputEl = document.querySelector("product-form quantity-input input");
    this.currentVariant = this.data.variants.find(({ id }) => id === +this.dataset.currentVariantId);
    if (!this.qtyInputEl || !this.currentVariant) return;

    this.quantityEl = this.querySelector(".qty");
    this.priceEl = this.querySelector(".price");
    this.frequencyEl = this.querySelector(".frequency");
    this.variantsEl = this.querySelector(".variants");
    this.buttonEl = this.querySelector("button");

    this.init();
  }

  init() {
    // Shows/hide element if product info is visible or not
    const intersectObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) this.classList.add("hidden");
        else this.classList.remove("hidden");
      });
    });
    intersectObserver.observe(this.productContainer);

    document.addEventListener("DOMContentLoaded", () => {
      this.updateInfo();
    });
    const mutationObserver = new MutationObserver(() => {
      this.updateInfo();
    });
    mutationObserver.observe(this.form, { attributes: true, childList: false, subtree: true });

    this.qtyInputEl.addEventListener("change", (e) => {
      this.updateInfo();
    });

    document.addEventListener("variant:changed", (e) => {
      if (!e.detail || !e.detail.options) return;

      this.currentVariant =
        e.detail.variant ??
        this.data.variants.find(({ options }) => options.every((o) => e.detail.options.includes(o)));
      this.variantsEl.innerText = e.detail.options.join(" · ");

      if (!this.currentVariant) {
        this.buttonEl.disabled = true;
        this.buttonEl.innerText = "Unavailable";
      } else if (this.currentVariant && !this.currentVariant.available) {
        this.buttonEl.disabled = true;
        this.buttonEl.innerText = "Out of stock";
      } else {
        this.buttonEl.disabled = false;
        this.buttonEl.innerText = "Add to cart";
      }

      this.updateInfo();
    });

    this.buttonEl.addEventListener("click", (e) => this.addToCart(e.target));
  }

  updateInfo() {
    if (!this.currentVariant) return;

    const sellingPlanId =
      this.form.elements["selling_plan"] && this.form.elements["selling_plan"].value !== ""
        ? this.form.elements["selling_plan"].value
        : null;
    const qty = +this.qtyInputEl.value;

    this.frequencyEl.innerHTML = "Buy once";
    this.priceEl.innerHTML = `${moneyFormat((this.currentVariant.price * qty) / 100)}`;
    this.quantityEl.innerHTML = this.qtyInputEl.value;

    if (sellingPlanId) {
      const sellingPlan = this.data.selling_plan_groups[0].selling_plans.find(({ id }) => id === +sellingPlanId);
      if (!sellingPlan) return;
      this.frequencyEl.innerHTML = sellingPlan.name;

      if (sellingPlan.price_adjustments.length > 0 && this.priceEl) {
        const [priceAdjustment] = sellingPlan.price_adjustments;
        const adjustment =
          priceAdjustment.value_type === "percentage"
            ? this.currentVariant.price - Math.round(this.currentVariant.price * (priceAdjustment.value / 100))
            : this.currentVariant.price - priceAdjustment.value;
        this.priceEl.innerHTML = `${moneyFormat((adjustment * qty) / 100)}`;
      }
    }
  }

  addToCart(target) {
    const formSubmit = document.querySelector('form[action="/cart/add"] button[type="submit"]');
    if (!formSubmit) return;
    target.classList.add("btn--loading");

    if (this.productContainer) {
      this.productContainer.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

    formSubmit.click();
    target.classList.remove("btn--loading");
  }
}

customElements.define("sticky-product-atc", StickyProductATC);

class WidgetSubscription extends HTMLElement {
  constructor() {
    super();

    this.selectSubscription = this.querySelector('select[name="product-subscription"]');
    this.selectSubscription.addEventListener("change", (e) => {
      document.dispatchEvent(
        new CustomEvent("subscriptionDelivery:changed", {
          detail: {
            select: e.target,
          },
        })
      );
    });

    const selections = this.querySelectorAll(".selection");
    selections.forEach((el) => {
      el.addEventListener("click", () => {
        selections.forEach((el) => el.classList.remove("active"));
        el.classList.add("active");

        document.dispatchEvent(
          new CustomEvent("subscriptionType:changed", {
            detail: { el },
          })
        );
      });
    });

    document.addEventListener("variant:changed", this.updateWidgetInfo);
  }

  updateWidgetInfo(e) {
    const { variant } = e.detail;
    if (!variant) return;

    const { price, selling_plan_allocations } = variant;
    const recurringPrice = this.querySelector(".recurring .money");
    const onetimePrice = this.querySelector(".one-time .money");

    if (recurringPrice) {
      const first = selling_plan_allocations ? selling_plan_allocations[0] : null;
      if (!first) return;

      recurringPrice.innerHTML = `${moneyFormat(first.price / 100)}<del>${moneyFormat(price / 100)}</del>`;
    }

    if (onetimePrice) {
      onetimePrice.innerHTML = moneyFormat(price / 100);
    }
  }
}
customElements.define("widget-subscription", WidgetSubscription);

class FakeSelect extends HTMLElement {
  constructor() {
    super();

    this.root = this.closest("variant-selects") || this.closest("variant-selects-stepped");
    this.container = this.closest(".product-form__input");
    this.select = this.container.querySelector("select");
    this.isSteppedExp = this.root.classList.contains("stepped-experience");
    this.details = this.querySelector("details");
    this.outsideClickAbortController = new AbortController();
    this.outsideClickAbortControllerSignal = this.outsideClickAbortController.signal;

    if (!this.select) return;

    this.summary = this.querySelector("details summary");
    this.selection = this.querySelector("details ul");

    // Handles selecting an option.
    this.selection.addEventListener("click", (e) => {
      if (this.selection.closest("faux-select").classList.contains("disabled")) return;
      const { value } = e.target.dataset;

      this.select.value = value;
      this.value_name = this.select.options[this.select.selectedIndex].text;
      this.select.dispatchEvent(new Event("change"));
      this.root.dispatchEvent(new Event("change"));

      this.summary.innerText = this.isSteppedExp ? this.value_name : value;
      this.summary.click();
    });

    // Handles opening & closing the details element.
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      const self = this;
      function closeDetails() {
        self.details.removeAttribute("open");
        self.details.style.display = "none";
        self.selection.style.display = "none";
        self.details.offsetHeight;
        self.outsideClickAbortController.abort();
        self.details.style.display = "block";
      }

      function handleOutsideClick(e) {
        if (self.isClickedOutside(e, self)) {
          closeDetails();
        }
      }

      if (self.details.hasAttribute("open")) {
        closeDetails();
      } else {
        self.details.setAttribute("open", "");
        self.selection.style.display = "block";
        self.outsideClickAbortController = new AbortController();
        self.outsideClickAbortControllerSignal = self.outsideClickAbortController.signal;
        document.body.addEventListener("click", handleOutsideClick, { signal: self.outsideClickAbortControllerSignal });
      }
    });
  }

  isClickedOutside(event, element) {
    const elementDimensions = element.getBoundingClientRect();
    const isClickOutside = !(
      event.clientX > elementDimensions.left &&
      event.clientX < elementDimensions.right &&
      event.clientY > elementDimensions.top &&
      event.clientY < elementDimensions.bottom
    );
    return isClickOutside;
  }
}
if (!customElements.get("faux-select")) {
  customElements.define("faux-select", FakeSelect);
}
